import { useForm } from "react-weaver";

import { useAuthenticate } from "./useAuthenticate";

export function useLoginForm({ initialValues } = {}) {
  const { authenticate } = useAuthenticate();
  return useForm({ initialValues, onSubmit: authenticate });
}
